import React, {useContext} from "react";
import {Image} from "react-bootstrap";
import {ERROR_TIME} from "./Constants";
import $ from 'jquery';
import {AuthContext} from "../context/authContext";
import Avatar from "../components/shared/Avatar";
import ItemImage from "../components/shared/ItemImage";
import MenuImage from "../components/shared/MenuImage";

const token = `document.querySelector('meta[name="csrf-token"]').content`;

export default function CurrentUser() {
  const { user } = useContext(AuthContext);
  return user;
}

export async function fetchData(url, callback, callback2) {
  fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      throw new Error("Network response was not ok.");
    })
    .then((response) => {
      if (callback2 && callback) {
        callback2(callback(response))
      } else if (callback) {
        callback(response)
      }
    })
    .catch((error) => {
      console.log(error);
      // alert('error')
    });
}

// TODO: remove dataKey
export function deleteItem(event, id, deleteCall, dataKey = 'key') {
  event.preventDefault()
  deleteData({ deleteCall, variables: { id: id }, dataKey: dataKey })
}

export function deleteCustomItem(event, variables, deleteCall, dataKey = 'key') {
  event.preventDefault()
  deleteData({ deleteCall, variables: variables, dataKey: dataKey })
}

export function deleteData({ deleteCall, variables, dataKey, callback, callback2 }) {
  if (window.confirm('Sunteți sigur?'))
    deleteCall({
      variables,
      onCompleted: (message) => {
        if (process.env.NODE_ENV !== 'production') {
          console.log('onCompleted: ', message)
        }
      },
      onError: (errors) => {
        console.log('onError: ', errors)
        console.log(Object.keys(errors))

        console.log(errors.message)

        alert(errors.message)
      }
    })

  // fetch(`${url}`, {
  //   method: 'DELETE',
  //   headers: {
  //     "X-CSRF-Token": token,
  //     "Content-Type": "application/json",
  //   }
  // })
  //   .then((response) => {
  //     if (response.ok) {
  //       return response.json();
  //     }
  //     throw new Error("Network response was not ok.");
  //   })
  //   .then((response) => {
  //     if (callback2 && callback) {
  //       callback2(callback(response))
  //     } else if (callback) {
  //       callback(response)
  //     }
  //   })
  //   .catch((error) => {
  //     console.log(error);
  //     // alert('error')
  //   });
}

export function saveData({ event, gqlCall, query_key, success, fail, flash_callback, extraData = [] }) {
  event.preventDefault();
  event.stopPropagation();

  const form = event.target;
  const formJson = Object.fromEntries(new FormData(form).entries());

  let data = {}
  data = formJson

  if (extraData.length) {
    extraData.forEach((item) => {
      data[item.key] = item.value
    })
  }
  if (process.env.NODE_ENV !== 'production') {
    console.log(`SavingData: -${query_key}-`, data)
  }

  sendToAPI({ form, data, gqlCall, query_key, success, fail, flash_callback })
}

export const sendToAPI = ({ form, data, gqlCall, query_key, success, fail, flash_callback }) => {
  gqlCall({
    variables: data,
    onCompleted: ({ [query_key]: response }) => {
      if (process.env.NODE_ENV !== 'production') {
        console.log('onCompleted', response)
      }
      if (response) {
        handleFormSuccess(form, flash_callback)
        if (success) success(response)
      } else {
        if (flash_callback)
          flash_callback({ type: 'danger', message: 'Datele nu au putut fi salvate' })
        if (fail) fail(response)
      }
    },
    onError: ({ graphQLErrors }) => {
      console.log('onError', graphQLErrors)
      handleGqlFormErrors(form, graphQLErrors, flash_callback)
    }
  });
}

export function organizationHeader(organization = {}) {
  let header = "";
  if (organization.id) header =
    <div className="hero position-relative d-flex align-items-center justify-content-center">
      <Image roundedCircle src={organization.avatar} alt={`${organization.name} image`} className="float-start"
             style={{ height: '80px' }} />
      <div className="display-6 float-start text-black">{organization.name}</div>
    </div>;
  return header;
}

export function dataForSelect(data, label_key = 'name', value_key = 'id') {
  if (typeof (label_key) === 'string')
    return data.map((item) => ({ label: item[label_key], value: item[value_key] }));
  else
    return data.map((item) => {
      const label = label_key.map(label => item[label]).filter(a => a != null)
      return { label: label.join(': '), value: item[value_key] }
    });
}

export function selectValue(data, label_key = 'name', value_key = 'id') {
  if (data === undefined) return {}
  return { label: data[label_key], value: data[value_key] }
}

export function selectedValue(data, value, labelKey = 'name', valueKey = 'id') {
  if (data === undefined || value === undefined) return {}

  const item = data.find(el => String(el[valueKey]) === String(value))
  return { label: item[labelKey], value: item[valueKey] }
}

function markAsInvalid(element, message) {
  element.removeClass('is-valid').addClass('is-invalid');
  element.after($(`<div class="invalid-feedback">${message}</div>`).prop('outerHTML'));
}

export function handleFormSuccess(form, flash_callback) {
  $(form).find('.form-control, div').removeClass('is-valid is-invalid');
  $(form).find('input, select, button').attr('disabled', true)
  $('.should-disable').attr('disabled', true)
  setTimeout((() => $(form).find('input, select, button').attr('disabled', false)), ERROR_TIME)
  setTimeout((() => $('.should-disable').attr('disabled', false)), ERROR_TIME)
  if (flash_callback)
    flash_callback({ type: 'success', message: 'Datele au fost salvate' });
}

// export function filtersToQueryString(filters) {
//   let keys = Object.keys(filters);
//   let params = '';
//
//   if (keys.length > 0) {
//     let urlFilters = {}
//     keys.forEach((key) => {
//       if (filters[key] != undefined && filters[key] != '')
//         urlFilters[key] = filters[key]
//     })
//     params = `?${new URLSearchParams(urlFilters).toString()}`;
//   }
//   return params
// }

function camelize(str) {
  str = str.replaceAll('_', ' ')
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
    return index === 0 ? word.toLowerCase() : word.toUpperCase();
  }).replace(/\s+|_/g, '');
}

export function handleGqlFormErrors(form, graphQLErrors, flash_callback) {
  let message

  $(form).find(`.form-control, [class*='-validatable'] [class*='-control']`).removeClass('is-invalid').addClass('is-valid');
  $(form).find(`.form-control, [class*='is-invalid']`).removeClass('is-invalid').addClass('is-valid');
  // console.log(graphQLErrors)

  if (!graphQLErrors || graphQLErrors.length === 0)
    return
  let errors = graphQLErrors[0].message
  // console.log(errors)
  try {
    errors = JSON.parse(errors)

    console.log(errors)
    Object.keys(errors).forEach((key, index) => {
      key = key.replace('.', '_')
      $(form).find('.invalid-feedback').remove();

      let element = $(form).find(`.form-control[name=${camelize(key)}]`);
      if (element.length === 0)
        element = $(form).find(`.form-control[id=${camelize(key)}]`);
      if (element.length === 0)
        element = $(form).find(`div[id=${camelize(key)}]`);

      let div_element = $(form).find(`.${key}-validatable [class*='-control']`);
      if (div_element.length === 0)
        div_element = $(form).find(`#${key}`);

      if (element.length > 0)
        setTimeout(() => markAsInvalid(element, errors[key]), 1);
      else if (div_element.length > 0)
        setTimeout(() => markAsInvalid(div_element, errors[key]), 1);
    })
    message = 'Datele nu au putut fi salvate'
  } catch (try_error) {
    message = errors
  }

  if (flash_callback)
    flash_callback({ type: 'danger', message: message })
}

export const tableImageTag = (item, options = {}) => {
  const type = options.type ||= 'image'
  options.width ||= 30
  options.height ||= 30
  options.className ||= 'object-fit-cover rounded rounded-circle me-2'
  options.src ||= item.image

  if (type === 'avatar')
    return <Avatar {...options}></Avatar>
  else if (type === 'menu')
    return <MenuImage {...options}></MenuImage>
  else if (type === 'image')
    return <ItemImage {...options}></ItemImage>

  return <img
    src={options.src || item.image}
    width={options.width} height={options.height}
    className={options.className}
    alt={options.alt}
  />
}

export const truncateString = (string = '', maxLength = 50) =>
  string && string.length > maxLength
    ? `${string.substring(0, maxLength)}…`
    : string
